import { RecoveryViewAction, RecoveryViewState } from "./recovery.view.types";

export const recoveryViewSetAction = (view: RecoveryViewState): RecoveryViewAction => ({ type: 'RECOVERY_VIEW_SET', params: view })
export const recoveryViewClearAction = (): RecoveryViewAction => ({ type: 'RECOVERY_VIEW_CLEAR' })